import { Component, OnInit } from '@angular/core';
import { IPasswordReset } from '../interfaces/ipassword-reset';
import { AuthService } from '../services/auth.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';

declare var $ : any;

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  public passDetail : IPasswordReset;
  public serverMessage : string = "";
  public successMsg : boolean = false;
  constructor(private userservice : AuthService) { }

  ngOnInit() {
    this.passDetail ={username : "", oldpassword : "", newpassword : "", confirmpassword: ""};
    $('.pass_show').append('<span class="ptxt">Show</span>'); 

    $(document).on('click','.pass_show .ptxt', function(){ 

      $(this).text($(this).text() == "Show" ? "Hide" : "Show"); 
      
      $(this).prev().attr('type', 
          function(index, attr)
           { 
            return attr == 'password' ? 'text' : 'password';
           }); 
      
      });  
  }


  onSubmit(){
     this.passDetail.username = this.userservice.getCurrentUser().sub;
     if(this.passDetail.newpassword === this.passDetail.confirmpassword){
       console.log(this.passDetail);
      this.userservice.changePassword(this.passDetail).subscribe(
        res => {
          Swal.fire("Password Changed Successful!! You could logout and login with your new password!!");
          //this.userservice.loggedOut();
        }
      );
     }
     

  }

}
